import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=ecea7f0c&scoped=true"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js"
import style0 from "./YoutubeEmbed.vue?vue&type=style&index=0&id=ecea7f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecea7f0c",
  null
  
)

export default component.exports